import { Layout } from "@/components/Layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  UsageSummaryCards,
  UsageChart,
  QuotaSettings,
  UsageLogTable,
} from "@/components/api-usage";
import {
  useApiUsageSummary,
  useApiQuotas,
  useDailyUsage,
} from "@/hooks/useApiUsage";

export default function ApiUsage() {
  const { data: summary, isLoading: loadingSummary } = useApiUsageSummary();
  const { data: quotas, isLoading: loadingQuotas } = useApiQuotas();
  const { data: dailyUsage, isLoading: loadingDaily } = useDailyUsage(30);

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">API-käyttö</h1>
          <p className="text-muted-foreground mt-2">
            Seuraa ja hallitse SMS- ja sähköpostipalveluiden käyttöä
          </p>
        </div>

        {/* Summary cards */}
        <UsageSummaryCards summary={summary || []} isLoading={loadingSummary} />

        {/* Tabs for different views */}
        <Tabs defaultValue="chart" className="space-y-4">
          <TabsList>
            <TabsTrigger value="chart">Käyttökaavio</TabsTrigger>
            <TabsTrigger value="logs">Tapahtumaloki</TabsTrigger>
            <TabsTrigger value="settings">Asetukset</TabsTrigger>
          </TabsList>

          <TabsContent value="chart">
            <UsageChart data={dailyUsage || []} isLoading={loadingDaily} />
          </TabsContent>

          <TabsContent value="logs">
            <UsageLogTable />
          </TabsContent>

          <TabsContent value="settings">
            <QuotaSettings quotas={quotas || []} isLoading={loadingQuotas} />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
